<template>
    <div v-if="showShippingPlan">
        <div class="flex justify-center pt-5">
            <div class="max-w-full overflow-x-auto mb-5">
                <ul class="mb-5 pl-[200px] flex">
                    <li
                        v-for="(position, index) in positionsAndWaitingTasks"
                        :key="position"
                        class="flex items-center flex-col justify-start step relative"
                        :class="{
                            'step-primary': position.tasks?.length,
                            [`w-[${450 * (position.tasks?.length || 1)}px]`]: true,
                            [`min-w-[${450 * (position.tasks?.length || 1)}px]`]: true
                        }">
                        <div
                            :class="{
                                [`w-[${450 * (position.tasks?.length || 1)}px]`]: true,
                                [`min-w-[${450 * (position.tasks?.length || 1)}px]`]: true
                            }">
                            <h3
                                v-if="index !== positionsAndWaitingTasks.length - 1"
                                class="absolute right-0 z-auto text-error-500"
                                style="transform: translateX(50%)">
                                {{ $formatters.convertMinutesToNaturalLanguage(position?.travelTimeToNextPosition?.duration || 0, 'second') }}
                            </h3>
                            <p class="text-lg font-bold text-center">
                                {{ position.nodeLocationName }}
                            </p>
                        </div>

                        <div
                            v-if="position?.tasks"
                            class="flex"
                            :class="{
                                [`w-[${450 * (position.tasks?.length || 1)}px]`]: true,
                                [`min-w-[${450 * (position.tasks?.length || 1)}px]`]: true
                            }">
                            <div
                                v-for="task in position.tasks"
                                :key="task"
                                class="w-[450px] mb-2 px-2 box-border h-full text-default-500">
                                <p class="text-center">
                                    {{ task.name || task.taskName }}
                                </p>
                                <div class="flex justify-around text-center text-info-700">
                                    <h3>
                                        Bắt đầu
                                    </h3>
                                    <h3>
                                        Kết thúc
                                    </h3>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
                <!-- gốc -->
                <table
                    v-if="CEarliest"
                    class="table-auto box-border">
                    <tbody>
                        <tr>
                            <td class="text-right w-[200px]">
                                <h4 class="w-[200px] my-2">
                                    Tính toán từ thời hạn gốc
                                </h4>
                            </td>
                        </tr>
                    </tbody>
                    <tbody
                        v-for="(earliest, index) in CEarliest"
                        :key="earliest">
                        <template v-if="earliest && earliest.data.length">
                            <tr
                                :class="{
                                    'text-success-500': true
                                    // 'text-warning-500': earliest.timeType === 'LATEST'
                                }">
                                <td class="text-right w-[200px]">
                                    <h4
                                        v-if="index === 0"
                                        class="w-[200px] my-2">
                                        {{ $t(`labels.earliest`) }}
                                    </h4>
                                </td>

                                <template
                                    v-for="(data, dataIndex) in earliest.data"
                                    :key="data">
                                    <td
                                        v-for="(task, indexTask) in data"
                                        :key="task"
                                        class="text-center w-[450px]">
                                        <div class="w-full flex justify-around flex-row items-center my-2">
                                            <!-- task: {{ task }} -->

                                            <div>
                                                <div
                                                    v-if="task?.in && task?.inOriginal"
                                                    class="w-[225px] flex justify-center">
                                                    <date-time
                                                        v-model="task.in"
                                                        class="w-[150px] min-w-[150px]"
                                                        disabled
                                                        :color="getDateTimeColor(data.timeType)" />
                                                </div>
                                                <h5
                                                    v-else
                                                    class="w-[225px]">
                                                    {{ convertDateFormat(task?.in) }}
                                                </h5>
                                            </div>

                                            <div>
                                                <div
                                                    v-if="task?.out && task?.outOriginal"
                                                    class="w-[225px] flex justify-center">
                                                    <date-time
                                                        v-model="task.out"
                                                        class="w-[150px] min-w-[150px]"
                                                        disabled
                                                        :color="getDateTimeColor(data.timeType)" />
                                                </div>
                                                <h5
                                                    v-else
                                                    class="w-[225px]">
                                                    {{ convertDateFormat(task?.out) }}
                                                </h5>
                                            </div>
                                        </div>
                                    </td>
                                </template>
                            </tr>
                        </template>
                    </tbody>
                </table>

                <table
                    v-if="CLatest"
                    class="table-auto box-border">
                    <tbody
                        v-for="(latest, index) in CLatest"
                        :key="latest">
                        <template v-if="latest && latest.data.length">
                            <tr
                                :class="{
                                    'text-warning-500': true
                                }">
                                <td class="text-right w-[200px]">
                                    <h4
                                        v-if="index === 0"
                                        class="w-[200px] my-2">
                                        {{ $t(`labels.latest`) }}
                                    </h4>
                                </td>

                                <template
                                    v-for="(data, dataIndex) in latest.data"
                                    :key="data">
                                    <td
                                        v-for="(task, indexTask) in data"
                                        :key="task"
                                        class="text-center w-[450px]">
                                        <div class="w-full flex justify-around flex-row items-center my-2">
                                            <!-- task: {{ task }} -->

                                            <div>
                                                <div
                                                    v-if="task?.in && task?.inOriginal"
                                                    class="w-[225px] flex justify-center">
                                                    <date-time
                                                        v-model="task.in"
                                                        class="w-[150px] min-w-[150px]"
                                                        disabled
                                                        :color="getDateTimeColor(data.timeType)" />
                                                </div>
                                                <h5
                                                    v-else
                                                    class="w-[225px]">
                                                    {{ convertDateFormat(task?.in) }}
                                                </h5>
                                            </div>

                                            <div>
                                                <div
                                                    v-if="task?.out && task?.outOriginal"
                                                    class="w-[225px] flex justify-center">
                                                    <date-time
                                                        v-model="task.out"
                                                        class="w-[150px] min-w-[150px]"
                                                        disabled
                                                        :color="getDateTimeColor(data.timeType)" />
                                                </div>
                                                <h5
                                                    v-else
                                                    class="w-[225px]">
                                                    {{ convertDateFormat(task?.out) }}
                                                </h5>
                                            </div>
                                        </div>
                                    </td>
                                </template>
                            </tr>
                        </template>
                    </tbody>
                </table>
                <!-- tổng hợp -->
                <table
                    v-if="CEarliestAggregation"
                    class="table-auto box-border">
                    <tbody>
                        <tr>
                            <td class="text-right w-[200px]">
                                <h4 class="w-[200px] my-2">
                                    Tổng hợp tính toán các luồng
                                </h4>
                            </td>
                        </tr>
                    </tbody>
                    <tbody
                        v-for="(earliest, index) in CEarliestAggregation"
                        :key="earliest">
                        <template v-if="earliest && earliest.data.length">
                            <tr
                                :class="{
                                    'text-success-500': true
                                    // 'text-warning-500': earliest.timeType === 'LATEST'
                                }">
                                <td class="text-right w-[200px]">
                                    <h4
                                        v-if="index === 0"
                                        class="w-[200px] my-2">
                                        {{ $t(`labels.earliest`) }}
                                    </h4>
                                </td>

                                <template
                                    v-for="(data, dataIndex) in earliest.data"
                                    :key="data">
                                    <td
                                        v-for="(task, indexTask) in data"
                                        :key="task"
                                        class="text-center w-[450px]">
                                        <div class="w-full flex justify-around flex-row items-center my-2">
                                            <!-- task: {{ task }} -->

                                            <div>
                                                <div
                                                    v-if="task?.in && task?.inOriginal"
                                                    class="w-[225px] flex justify-center">
                                                    <date-time
                                                        v-model="task.in"
                                                        class="w-[150px] min-w-[150px]"
                                                        disabled
                                                        :color="getDateTimeColor(data.timeType)" />
                                                </div>
                                                <h5
                                                    v-else
                                                    class="w-[225px]">
                                                    {{ convertDateFormat(task?.in) }}
                                                </h5>
                                            </div>

                                            <div>
                                                <div
                                                    v-if="task?.out && task?.outOriginal"
                                                    class="w-[225px] flex justify-center">
                                                    <date-time
                                                        v-model="task.out"
                                                        class="w-[150px] min-w-[150px]"
                                                        disabled
                                                        :color="getDateTimeColor(data.timeType)" />
                                                </div>
                                                <h5
                                                    v-else
                                                    class="w-[225px]">
                                                    {{ convertDateFormat(task?.out) }}
                                                </h5>
                                            </div>
                                        </div>
                                    </td>
                                </template>
                            </tr>
                        </template>
                    </tbody>
                </table>

                <table
                    v-if="CLatestAggregation"
                    class="table-auto box-border">
                    <tbody
                        v-for="(latest, index) in CLatestAggregation"
                        :key="latest">
                        <template v-if="latest && latest.data.length">
                            <tr
                                :class="{
                                    'text-warning-500': true
                                }">
                                <td class="text-right w-[200px]">
                                    <h4
                                        v-if="index === 0"
                                        class="w-[200px] my-2">
                                        {{ $t(`labels.latest`) }}
                                    </h4>
                                </td>

                                <template
                                    v-for="(data, dataIndex) in latest.data"
                                    :key="data">
                                    <td
                                        v-for="(task, indexTask) in data"
                                        :key="task"
                                        class="text-center w-[450px]">
                                        <div class="w-full flex justify-around flex-row items-center my-2">
                                            <!-- task: {{ task }} -->

                                            <div>
                                                <div
                                                    v-if="task?.in && task?.inOriginal"
                                                    class="w-[225px] flex justify-center">
                                                    <date-time
                                                        v-model="task.in"
                                                        class="w-[150px] min-w-[150px]"
                                                        disabled
                                                        :color="getDateTimeColor(data.timeType)" />
                                                </div>
                                                <h5
                                                    v-else
                                                    class="w-[225px]">
                                                    {{ convertDateFormat(task?.in) }}
                                                </h5>
                                            </div>

                                            <div>
                                                <div
                                                    v-if="task?.out && task?.outOriginal"
                                                    class="w-[225px] flex justify-center">
                                                    <date-time
                                                        v-model="task.out"
                                                        class="w-[150px] min-w-[150px]"
                                                        disabled
                                                        :color="getDateTimeColor(data.timeType)" />
                                                </div>
                                                <h5
                                                    v-else
                                                    class="w-[225px]">
                                                    {{ convertDateFormat(task?.out) }}
                                                </h5>
                                            </div>
                                        </div>
                                    </td>
                                </template>
                            </tr>
                        </template>
                    </tbody>
                </table>

                <!-- tối ưu -->
                <table
                    v-if="CEarliestOptimalConditions"
                    class="table-auto box-border">
                    <tbody>
                        <tr>
                            <td class="text-right w-[200px]">
                                <h4 class="w-[200px] my-2">
                                    Tối ưu thời gian chờ
                                </h4>
                            </td>
                        </tr>
                    </tbody>
                    <tbody
                        v-for="(earliest, index) in CEarliestOptimalConditions"
                        :key="earliest">
                        <template v-if="earliest && earliest.data.length">
                            <tr
                                :class="{
                                    'text-success-500': true
                                    // 'text-warning-500': earliest.timeType === 'LATEST'
                                }">
                                <td class="text-right w-[200px]">
                                    <h4
                                        v-if="index === 0"
                                        class="w-[200px] my-2">
                                        {{ $t(`labels.earliest`) }}
                                    </h4>
                                </td>

                                <template
                                    v-for="(data, dataIndex) in earliest.data"
                                    :key="data">
                                    <td
                                        v-for="(task, indexTask) in data"
                                        :key="task"
                                        class="text-center w-[450px]">
                                        <div class="w-full flex justify-around flex-row items-center my-2">
                                            <!-- task: {{ task }} -->

                                            <div>
                                                <span
                                                    v-if="getWaitingTimes(dataIndex, indexTask)?.waitingTime"
                                                    class="text-sm text-error-500">
                                                    Chờ: {{ $formatters.convertMinutesToNaturalLanguage((getWaitingTimes(dataIndex, indexTask).waitingTime || 0) / 60 / 1000, 'minute') }}
                                                </span>
                                                <div
                                                    v-if="task?.in && task?.inOriginal"
                                                    class="w-[225px] flex justify-center">
                                                    <date-time
                                                        v-model="task.in"
                                                        class="w-[150px] min-w-[150px]"
                                                        disabled
                                                        :color="getDateTimeColor(data.timeType)" />
                                                </div>
                                                <h5
                                                    v-else
                                                    class="w-[225px]">
                                                    {{ convertDateFormat(task?.in) }}
                                                </h5>
                                            </div>

                                            <div>
                                                <div
                                                    v-if="task?.out && task?.outOriginal"
                                                    class="w-[225px] flex justify-center">
                                                    <date-time
                                                        v-model="task.out"
                                                        class="w-[150px] min-w-[150px]"
                                                        disabled
                                                        :color="getDateTimeColor(data.timeType)" />
                                                </div>
                                                <h5
                                                    v-else
                                                    class="w-[225px]">
                                                    {{ convertDateFormat(task?.out) }}
                                                </h5>
                                            </div>
                                        </div>
                                    </td>
                                </template>
                            </tr>
                        </template>
                    </tbody>
                </table>

                <table
                    v-if="CLatestOptimalConditionsn"
                    class="table-auto box-border">
                    <tbody
                        v-for="(latest, index) in CLatestOptimalConditionsn"
                        :key="latest">
                        <template v-if="latest && latest.data.length">
                            <tr
                                :class="{
                                    'text-warning-500': true
                                }">
                                <td class="text-right w-[200px]">
                                    <h4
                                        v-if="index === 0"
                                        class="w-[200px] my-2">
                                        {{ $t(`labels.latest`) }}
                                    </h4>
                                </td>

                                <template
                                    v-for="(data, dataIndex) in latest.data"
                                    :key="data">
                                    <td
                                        v-for="(task, indexTask) in data"
                                        :key="task"
                                        class="text-center w-[450px]">
                                        <div class="w-full flex justify-around flex-row items-center my-2">
                                            <!-- task: {{ task }} -->

                                            <div>
                                                <div
                                                    v-if="task?.in && task?.inOriginal"
                                                    class="w-[225px] flex justify-center">
                                                    <date-time
                                                        v-model="task.in"
                                                        class="w-[150px] min-w-[150px]"
                                                        disabled
                                                        :color="getDateTimeColor(data.timeType)" />
                                                </div>
                                                <h5
                                                    v-else
                                                    class="w-[225px]">
                                                    {{ convertDateFormat(task?.in) }}
                                                </h5>
                                            </div>

                                            <div>
                                                <div
                                                    v-if="task?.out && task?.outOriginal"
                                                    class="w-[225px] flex justify-center">
                                                    <date-time
                                                        v-model="task.out"
                                                        class="w-[150px] min-w-[150px]"
                                                        disabled
                                                        :color="getDateTimeColor(data.timeType)" />
                                                </div>
                                                <h5
                                                    v-else
                                                    class="w-[225px]">
                                                    {{ convertDateFormat(task?.out) }}
                                                </h5>
                                            </div>
                                        </div>
                                    </td>
                                </template>
                            </tr>
                        </template>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>
<script setup lang="ts">
import DateTime from './component/date-time.vue'
const { $formatters, $disableReactive } = useNuxtApp()
const showShippingPlan = ref(false)
const positions = ref<Array<any>>([])
const shippingPlan = ref<{ [key: string]: any }>({})
const positionsAndWaitingTasks = ref<Array<any>>([])
const originalTaskCalculationResults = ref<Array<any>>([])
const streamAggregationAndCalculations = ref<Array<any>>([])
const optimalConditions = ref<Array<any>>([])
const waitingTimes = ref<Array<any>>([])

const show = (positionsData: Array<any>, shippingPlanData: { [key: string]: any }) => {
  showShippingPlan.value = true
  positions.value = $disableReactive(positionsData)
  shippingPlan.value = shippingPlanData

  positionsAndWaitingTasks.value = shippingPlanData.positionsAndWaitingTasks
  originalTaskCalculationResults.value = shippingPlanData.originalTaskCalculationResults
  streamAggregationAndCalculations.value = shippingPlanData.streamAggregationAndCalculations
  optimalConditions.value = shippingPlanData.optimalConditions
  waitingTimes.value = shippingPlanData.waitingTimes || []
}

const CEarliest = computed(() => {
  return originalTaskCalculationResults.value?.filter((item) => item.timeType === 'EARLIEST')
})

const CLatest = computed(() => {
  return originalTaskCalculationResults.value?.filter((item) => item.timeType === 'LATEST')
})

const CEarliestAggregation = computed(() => {
  return streamAggregationAndCalculations.value?.filter((item) => item.timeType === 'EARLIEST')
})

const CLatestAggregation = computed(() => {
  return streamAggregationAndCalculations.value?.filter((item) => item.timeType === 'LATEST')
})

const CEarliestOptimalConditions = computed(() => {
  return optimalConditions.value?.filter((item) => item.timeType === 'EARLIEST')
})

const CLatestOptimalConditionsn = computed(() => {
  return optimalConditions.value?.filter((item) => item.timeType === 'LATEST')
})

const getWaitingTimes = (positionIndex: number, taskIndex: number) => {
  const time = waitingTimes.value.find((item) => item.positionIndex === positionIndex && item.taskIndex === taskIndex)
  return time
}
const close = () => {
  showShippingPlan.value = false
  positions.value = []
}

const getDateTimeColor = (type: string) => {
  if (type === 'earliest' || type === 'EARLIEST') {
    return 'success'
  }

  if (type === 'latest' || type === 'LATEST') {
    return 'warning'
  }
}

const convertDateFormat = (inputDate: string | number): string => {
  if (!inputDate) {
    return ''
  }

  const date = new Date(inputDate)

  if (Number.isNaN(date.getTime())) {
    return ''
  }

  const day = String(date.getDate()).padStart(2, '0')
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const year = String(date.getFullYear())
  const hour = String(date.getHours()).padStart(2, '0')
  const minute = String(date.getMinutes()).padStart(2, '0')

  const formattedDate = `${day}-${month}-${year} ${hour}:${minute}`

  return formattedDate
}

defineExpose({ show, close })
</script>
